import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faTrash,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import IvrCard from "../../ivrs/IvrCard";
import Button from "../../layout/Button";
import { Queue } from "../../../model/queue.model";
import { WhatsappBotMenuOption } from "../../../model/whatsappBot.model";

function MenuOptionCard({
  option,
  queue,
  onOpenSubmenu,
  onEditOption,
  onDelete,
  className,
}: MenuOptionCardProps) {
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  const footer =
    option.type === "submenu" ? (
      <Button className="w-full" onClick={onOpenSubmenu}>
        Abrir submenu →
      </Button>
    ) : null;

  return (
    <IvrCard footer={footer} onClick={undefined} className={className || ""}>
      <div className="h-full">
        <div className="flex items-start justify-between mb-4 mt-2">
          <div className="rounded-full w-8 h-8 bg-primary text-white flex items-center justify-center font-bold text-sm flex-none">
            {option.option}
          </div>
          <div className="flex gap-1">
            <button
              type="button"
              aria-label="Editar opção"
              className="w-7 h-7 rounded-10 text-gray-dark hover:bg-white-dark"
              onClick={onEditOption}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="text-xs" />
            </button>
            {confirmingDelete ? (
              <button
                type="button"
                className="px-2 h-7 rounded-10 text-red bg-red/10 text-[11px] font-bold"
                onClick={() => {
                  setConfirmingDelete(false);
                  onDelete();
                }}
              >
                Remover?
              </button>
            ) : (
              <button
                type="button"
                aria-label="Remover opção"
                className="w-7 h-7 rounded-10 text-gray-dark hover:bg-red/10 hover:text-red"
                onClick={() => setConfirmingDelete(true)}
              >
                <FontAwesomeIcon icon={faTrash} className="text-xs" />
              </button>
            )}
          </div>
        </div>

        <div className="text-primary font-bold text-base 2xl:text-lg mb-2">
          {option.name}
        </div>

        <div className="flex items-center gap-1.5 mb-3 flex-wrap">
          <span
            className={`inline-flex items-center text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${
              option.type === "queue"
                ? "bg-green/10 text-green"
                : "bg-purple/10 text-purple"
            }`}
          >
            {option.type === "queue" ? "Fila" : "Submenu"}
          </span>
          {option.confirmationMessage && (
            <span
              className="inline-flex items-center text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-gray/10 text-gray-dark"
              title={option.confirmationMessage}
            >
              Com confirmação
            </span>
          )}
        </div>

        {option.type === "queue" && (
          <>
            {queue ? (
              queue.participants && queue.participants.length > 0 ? (
                <div className="text-gray-dark text-xs 2xl:text-sm">
                  {queue.participants.length}{" "}
                  {queue.participants.length === 1
                    ? "atendente"
                    : "atendentes"}{" "}
                  nesta fila
                </div>
              ) : (
                <div className="border-red border-2 py-1 px-2 rounded-10 flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className="text-red text-lg flex-none"
                  />
                  <div className="text-red text-xs font-bold">
                    Fila sem participantes
                  </div>
                </div>
              )
            ) : (
              <div className="text-gray-dark text-xs 2xl:text-sm">
                Fila: {option.queueId}
              </div>
            )}
          </>
        )}

        {option.type === "submenu" && (
          <div className="text-gray-dark text-xs 2xl:text-sm">
            {option.node.options.length === 0
              ? "Nenhuma opção configurada ainda"
              : `${option.node.options.length} ${
                  option.node.options.length === 1
                    ? "opção configurada"
                    : "opções configuradas"
                }`}
          </div>
        )}
      </div>
    </IvrCard>
  );
}

export default MenuOptionCard;

export type MenuOptionCardProps = {
  option: WhatsappBotMenuOption;
  queue?: Queue;
  onOpenSubmenu: () => void;
  onEditOption: () => void;
  onDelete: () => void;
  className?: string;
};
